/** Every word of the company typeahead (SA-1456 spec §7.1). */

export const NOT_LINKED = 'Not linked'
export const CLEAR_LINK = 'Clear company link'
export const COULDNT_CHECK = "Couldn't check"
export const SEARCHING = 'Searching…'
export const NO_MATCH = 'No company matches'
export const LINKED_FALLBACK = 'Linked company'

export const linkSuggestion = (name: string): string => `Link to ${name}?`
export const addCompany = (text: string): string => `Add '${text}' as a company`
export const alreadyOnFile = (name: string): string => `Already on file as ${name}; linked.`
export const addFailed = "Couldn't add the company"

const ROLE_LABELS: Record<string, string> = {
  customer: 'Customer', forwarder: 'Forwarder', broker: 'Broker', shipper: 'Shipper',
  consignee: 'Consignee', carrier: 'Carrier', affiliate: 'Affiliate',
}
/** A role in words; an id this build does not know reads as itself. */
export const roleLabel = (role: string): string => ROLE_LABELS[role] ?? role
